import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import { withRouter } from 'react-router'
import Select from 'react-select'
import Button from '../../common/CustomComponents/Button'

class AddReview extends React.Component {
  state = {
    rating_for: 'CRUISE',
    reference_id: '',
    rating: 5,
    comment: '',
    reviewer_name: '',
    is_featured: false,

    selectedReference: null,
    referenceList: [],


    ratingForOptions: [
      { label: 'Cruise', value: 'CRUISE' },
      { label: 'Chalet', value: 'CHALET' },
      // { label: 'Event', value: 'EVENT' },
      // { label: 'Kashta', value: 'KASHTA' },
      // { label: 'Trip', value: 'TRIP' },
    ],

    isSaving: false,
    Edit: false,
  }

  componentDidMount = () => {
    if (this.props.match.params.id) {
      this.setState(
        {
          id: this.props.match.params.id,
        },
        () => {
          this.getReviewDetails()
        }
      )
    } else {
      this.loadReferenceList('CRUISE')
    }
  }

  getReviewDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/get-review/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const review = res.data.data
          const country = localStorage.getItem('countryShortName')
          this.setState(
            {
              rating_for: review.rating_for,
              reference_id: review.cruise_id,
              rating: review.rating,
              comment: review.Comment,
              reviewer_name: review.reviewer_name || '',
              is_featured: review.is_featured,
              country: country,
              Edit: true,
            },
            () => {
              this.loadReferenceList(review.rating_for, review.cruise_id)
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadReferenceList = async (type, selectedId = null) => {
    if (!localStorage.getItem('countryShortName')) {
      this.setState({ referenceList: [] })
      return
    }

    let endpoint = ''
    let nameFieldEn = ''
    let nameFieldAr = ''
    let params = { country: localStorage.getItem('countryShortName') }

    switch (type) {
      case 'CRUISE':
        endpoint = '/cruise/list-cruise'
        nameFieldEn = 'cruise_name_en'
        nameFieldAr = 'cruise_name_ar'
        break
      case 'CHALET':
        endpoint = '/chalet/list-chalet'
        nameFieldEn = 'name_en'
        nameFieldAr = 'name_ar'
        break
      case 'EVENT':
        endpoint = '/event/list-events'
        nameFieldEn = 'event_name_en'
        nameFieldAr = 'event_name_ar'
        params.isActive = 'true'
        break
      default:
        return
    }

    await axios
      .get(Constant.getAPI() + endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: params,
      })
      .then((res) => {
        if (res.data.success || res.data.data) {
          let data = res.data.data || []

          const referenceList = data.map((item) => ({
            label: `${item[nameFieldEn] || item.name_en || ''} / ${item[nameFieldAr] || item.name_ar || ''}`,
            value: item.id,
          }))

          this.setState({ referenceList })

          if (selectedId) {
            const selected = referenceList.find((ref) => ref.value === selectedId)
            if (selected) {
              this.setState({ selectedReference: selected })
            }
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addReview = async () => {
    if (!this.state.selectedReference) {
      Swal.fire('Reference Required', 'Please select a cruise/chalet/event/kashta/trip', 'error')
      return
    }

    if (!this.state.comment || this.state.comment.trim() === '') {
      Swal.fire('Comment Required', 'Please enter a review comment', 'error')
      return
    }

    if (this.state.comment.length > 500) {
      Swal.fire('Comment Too Long', 'Comment must be 500 characters or less', 'error')
      return
    }

    const data = {
      rating_for: this.state.rating_for,
      reference_id: this.state.selectedReference.value,
      rating: parseFloat(this.state.rating),
      comment: this.state.comment,
      reviewer_name: this.state.reviewer_name || null,
      is_featured: this.state.is_featured,
    }

    this.setState({ isSaving: true })

    if (this.props.match.params.id) {
      await axios
        .put(Constant.getAPI() + `/admin/update-review/${this.props.match.params.id}`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            Swal.fire({
              title: 'Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/admin-review`
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    } else {
      axios
        .post(Constant.getAPI() + '/admin/create-review', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            Swal.fire({
              title: 'Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/admin-review`
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleRatingForChange = (event) => {
    const newRatingFor = event.target.value
    this.setState(
      {
        rating_for: newRatingFor,
        selectedReference: null,
        reference_id: '',
        referenceList: [],
      },
      () => {
        if (localStorage.getItem('countryShortName')) {
          this.loadReferenceList(newRatingFor, localStorage.getItem('countryShortName'))
        }
      }
    )
  }

  handleSelectReference = (event) => {
    this.setState({ selectedReference: event, reference_id: event.value })
  }

  handleCheckboxChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked })
  }

  renderStarRating = () => {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`icofont icofont-star`}
          style={{
            color: i <= this.state.rating ? '#FFD700' : '#ccc',
            fontSize: '24px',
            cursor: 'pointer',
            marginRight: '5px',
          }}
          onClick={() => this.setState({ rating: i })}
        ></i>
      )
    }
    return <div>{stars}</div>
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Rating For <span className="text-danger">*</span>
                </label>
                <div className="col-sm-9">
                  <select
                    className="form-control"
                    name="rating_for"
                    value={this.state.rating_for}
                    onChange={this.handleRatingForChange}
                  >
                    {this.state.ratingForOptions.map((option) => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Select {this.state.rating_for} <span className="text-danger">*</span>
                </label>
                <div className="col-sm-9">
                  <Select
                    value={this.state.selectedReference}
                    onChange={this.handleSelectReference}
                    options={this.state.referenceList}
                    placeholder={`Select ${this.state.rating_for}`}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Rating <span className="text-danger">*</span>
                </label>
                <div className="col-sm-9">{this.renderStarRating()}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Reviewer Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="reviewer_name"
                    value={this.state.reviewer_name}
                    onChange={this.handleChange}
                    placeholder="Enter reviewer name (optional)"
                    maxLength={100}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                  Comment <span className="text-danger">*</span>
                </label>
                <div className="col-sm-10">
                  <textarea
                    className="form-control"
                    name="comment"
                    value={this.state.comment}
                    onChange={this.handleChange}
                    placeholder="Enter review comment"
                    rows="5"
                    maxLength={500}
                  />
                  <small className="form-text text-muted">
                    {this.state.comment.length}/500 characters
                  </small>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Featured</label>
                <div className="col-sm-9">
                  <div className="checkbox-fade fade-in-primary">
                    <label>
                      <input
                        type="checkbox"
                        name="is_featured"
                        checked={this.state.is_featured}
                        onChange={this.handleCheckboxChange}
                      />
                      <span className="cr">
                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                      </span>
                      <span>Mark as Featured Review</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row float-right p-3">
            <Button
              disabled={this.state.isSaving}
              onClick={this.addReview}
              startIcon={<i className="icofont icofont-save"></i>}
            >
              {this.state.isSaving ? 'Saving...!' : this.state.Edit ? 'Update' : 'Save'}
            </Button>
            <Button
              onClick={() => (window.location.href = '#/admin-review')}
              variant="outlined"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(AddReview)
